<template>
    <div class="page-search">
        <div class="search-form">
            <!-- <div class="search-form-item">
                <span class="label">摘录:</span>
                <perfect-scrollbar :options="{ suppressScrollY: true }">
                    <u-checkbox :list="books" v-model="bookId" @change="onSearch" />
                </perfect-scrollbar>
            </div> -->
            <div class="search-form-item">
                <span class="label">拼音:</span>
                <perfect-scrollbar class="pc" :options="{ suppressScrollY: true }">
                    <u-checkbox :list="pys" v-model="pinyin" @change="onSearch" />
                </perfect-scrollbar>
                <u-checkbox class="sj" :list="pys" v-model="pinyin" @change="onSearch" />
            </div>
            <div class="">
                <span class="label">当前列表首字跳转:</span>
                <span class="word" @click="toPoing(item)" v-for="(item) in wordList" :key="item">{{ item }}</span>
            </div>
        </div>

        <div class="totalNum" v-if="totalNum"><span class="red">{{ totalNum }}</span>项</div>

        <div class="list">
            <el-row :gutter="50" v-if="bookList.length">
                <el-col :xs="12" :md="6" v-for="(item, index) in bookList" :key="index">
                    <a class="list-item" :class="item.word" @click="onItem(item)">
                        <span>
                            {{ item.drugName }}
                            <em>
                                <i class="sl" v-if="item.quantity > 1">{{ item.quantity }}</i>
                                <i class="tu" v-if="item.picture * 1">图</i>
                            </em>
                        </span>
                    </a>
                </el-col>
            </el-row>
            <el-empty v-else description="暂无数据"></el-empty>
        </div>
        <!-- <el-pagination class="pc" @size-change="sizeChange" @current-change="currentChange" :current-page.sync="currentPage"
            :page-sizes="[20, 40, 80, 100]" :page-size="pageSize" layout="total, prev, pager, next, sizes"
            :total="totalNum">
        </el-pagination>
        <el-pagination class="sj" @size-change="sizeChange" @current-change="currentChange" :current-page.sync="currentPage"
            layout="prev, pager, next " :total="totalNum">
        </el-pagination> -->
        <!-- <div class="to-top" @click="toTop">
            <i class="el-icon-top"></i>
        </div> -->
        <toTop />
    </div>
</template>

<script>
import UCheckbox from '@/components/uCheckbox.vue';
export default {
    props: {
        keyword: {
            type: String,
            default: "",
        },
    },
    components: {
        UCheckbox,
    },
    watch: {
        keyword() {
            this.init();
        }
    },
    data() {
        return {
            word: '',
            wordList: [],
            drugName: '', // 药品名称 
            pageIndex: 1, // 页码 
            // pageSize: 40, // 页大小 
            pageSize: 100000, // 页大小 
            pinyin: [], // 拼音码 

            currentPage: 1,
            totalNum: 0,
            bookId: [],
            books: [
                {
                    label: "《中国药典》",
                    value: 1,
                },
                {
                    label: "《全国中草药汇编》",
                    value: 2,
                },
                {
                    label: "《中药大辞典》",
                    value: 3,
                },
                {
                    label: "《中华本草》",
                    value: 4,
                },
                {
                    label: "其他",
                    value: 5,
                },
            ],
            pys: [
                "A",
                "B",
                "C",
                "D",
                "E",
                "F",
                "G",
                "H",
                "I",
                "J",
                "K",
                "L",
                "M",
                "N",
                "O",
                "P",
                "Q",
                "R",
                "S",
                "T",
                "U",
                "V",
                "W",
                "X",
                "Y",
                "Z"
            ],
            bookList: [],
        }
    },
    methods: {
        toPoing(item) {
            let listNode = this.$el.querySelector(".list");
            let node = this.$el.querySelector("." + item)
            let top = node.offsetTop;
            window.scrollTo(0, top + listNode.offsetTop - 70)
            node.classList.add("item-active")
            setTimeout(() => {
                node.classList.remove("item-active")
            }, 1000);
        },
        onItem(item) {
            this.jump('/drugDetail/' + item.drugName);
        },
        sizeChange(size) {
            this.pageSize = size;
            this.onSearch();
        },
        onSearch() {
            this.pageIndex = 1;
            this.getData();
        },
        currentChange(index) {
            this.pageIndex = index;
            this.getData();
        },
        getData() {
            let obj = {
                drugName: this.drugName, // 药品名称 
                pageIndex: this.pageIndex, // 页码 
                pageSize: this.pageSize, // 页大小 
                pinyin: this.pinyin.join(','), // 拼音码 
            }
            if (!obj.drugName && !obj.pinyin) {
                obj.pageSize = 50;
            }
            this.$store.commit("showLoading")
            this.api("listMedicinalMaterials", obj).then(res => {
                this.$store.commit("hideLoading")
                this.totalNum = res.total;
                this.getWord(res.result);
                this.bookList = res.result;
            })
        },
        getWord(list) {
            this.wordList = [];
            list.forEach(i => {
                let drugName = i.drugName;
                let index = 0;
                let d = drugName.match(/^（|\[/)
                if (d) {
                    if (d[0] == "（") {
                        index = drugName.indexOf("）")
                    } else {
                        index = drugName.indexOf("]")
                    }
                    index += 1;
                }
                let w = drugName.slice(index, index + 1)
                i.word = w;

                if (!this.wordList.find(j => j == w)) {
                    this.wordList.push(w)
                }
            })
        },
        init() {
            this.pinyin = [];
            this.drugName = this.keyword;
            this.onSearch();
        }
    },
    created() {
        this.init();

    },
}
</script>

<style lang="scss"></style>